import {
  GET_CLIENT_ROLES_FOR_USER,
  GET_CLIENT_ROLES_FOR_USER_SUCCESS,
  GET_CLIENT_ROLES_FOR_USER_ERROR,
  GET_CLIENT_ROLES_FOR_USER_EMPTY,
} from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetClientRoleForUser = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_ROLES_FOR_USER:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_ROLES_FOR_USER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_CLIENT_ROLES_FOR_USER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CLIENT_ROLES_FOR_USER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetClientRoleForUser;
